
import api from './api';

const endpoint = '/api/compras';

const ComprasService = {
  getAll: async () => {
    const response = await api.get(endpoint);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`${endpoint}/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post(endpoint, data);
    return response.data;
  },

  update: async (id, data) => {
    const { pago, cancelada } = data;

    const response = await api.put(
      `${endpoint}/${id}?pago=${pago}&cancelada=${cancelada}`
    );

    return response.data;
  },

  
  remove: async (id) => {
    const response = await api.delete(`${endpoint}/${id}`);
    return response.data;
  },
};

export default ComprasService;